<template>
  <div class="navbar-fixed-content" style="padding-top:70px;">
    <my-account-header></my-account-header>
    <div class="myinfo-bottom">
      <div class="cnt">
        <my-side-menu></my-side-menu>

        <div class="myinfo-con">
          <div class="tabbable-line">
            <ul class="nav nav-tabs">
              <li :class="[showCourse?'active':'']">
                <a class="a-tab" data-status="1" data-toggle="tab" @click="exhibitionCourse()">课程</a>
              </li>
              <li :class="[showCourse?'':'active']">
                <a class="a-tab" data-status="2" data-toggle="tab" @click="exhibitionClass()">培训</a>
              </li>
            </ul>
            <div class="tab-content">
              <div id="tab_2_1" :class="[showCourse?'tab-pane active':'tab-pane']">
                <div class="collect-t-list">
                  <div class="collect-course-item" v-for="item in courseLists">
                    <a @click="myCourseClick(item)" target="_blank">
                      <img aa="11" style="width:225px;height:150px;" :src="item.thumb" />
                      <h5>{{item.title}}</h5>
                    </a>
                  </div>
                </div> 
               <div class="opr" style="margin-bottom:20px" v-if="query_data[0].totalPage > 1">
                  <span class="my-course-page">
                    <span
                      class="page"
                    >{{query_data[0].PageIndex+1}}/{{query_data[0].totalPage}}</span>
                    <a class="page-prev prev" @click="pagePrevClicked(0)"></a>
                    <a class="page-next next" @click="pageNextClicked(0)"></a>
                  </span>
                </div>
              </div>
              <div id="tab_2_2" :class="[showCourse?'tab-pane':'tab-pane active']">
                <div class="banlist">
                  <div class="ban_item_c" v-for="item in classLists">
                    <a @click="myClassClick(item)">
                      <img :src="item.logo" class="banlogo" style="width:100%" />
                      <div class="title">{{item.name}}</div>
                    </a>
                  </div>
                </div>
                <div class="opr" style="margin-bottom:20px" v-if="query_data[1].totalPage > 1">
                  <span class="my-course-page" >
                    <span class="page">{{query_data[1].PageIndex}}/{{ Math.ceil(query_data[1].totalCount/query_data[1].MaxResultCount) }}</span>
                    <a class="page-prev prev" @click="pagePrevClicked(1)"></a>
                    <a class="page-next next" @click="pageNextClicked(1)"></a>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MyAccountHeader from "@/layout/MyAccountHeader";
import MySideMenu from "@/layout/MySideMenu";
import comFun from "@/common/common";
export default {
  components: {
    MyAccountHeader,
    MySideMenu,
  },
  data() {
    return {
      query_data: [
        {
          stopajax: !1,
          MaxResultCount: 8,
          PageIndex: 0,
          totalPage: 0,
          SkipCount: 0,
          totalCount: 0,
          index: 0,
          CourseType: 3,
        }, //课程
        {
          stopajax: !1,
          MaxResultCount: 6,
          PageIndex: 0,
          totalPage: 0,
          SkipCount: 0,
          totalCount: 0,
          index: 0,
        }, //培训
      ],
      courseLists: [],
      classLists: [],
      showCourse: true,
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    nav() {
      return this.$store.state.nav;
    },
  },
    created() {
      this.loadMoreCourse();
    this.loadMoreClass();
    },
  mounted() {

  },
  methods: {
    loadMoreCourse: function () {
      this.query_data[0].SkipCount = this.query_data[0].PageIndex*this.query_data[0].MaxResultCount;
      comFun.getMyCollectionCourseList(this.query_data[0]).then((res) => {
        this.courseLists = res.items;
        // this.courseLists = this.courseLists.concat(res.items);
        this.query_data[0].totalCount = res.totalCount;
        this.query_data[0].totalPage =Math.ceil( res.totalCount/ this.query_data[0].MaxResultCount);
       
        if (res.totalCount %  this.query_data[0].pageSize > 0) {
          this.query_data[0].totalPage++;
          
          
        }
      });
    },
    loadMoreClass: function () {
      this.query_data[1].SkipCount = this.query_data[1].PageIndex*this.query_data[1].MaxResultCount;
      comFun.getMyCollectionClassList(this.query_data[1]).then((res) => {
        this.classLists = res.items;
        // this.courseLists = this.courseLists.concat(res.items);
        this.query_data[1].totalCount = res.totalCount;
        this.query_data[1].totalPage =Math.ceil( res.totalCount/ this.query_data[1].MaxResultCount);
       
        if (res.totalCount %  this.query_data[1].pageSize > 0) {
          this.query_data[1].totalPage++;
          
          
        }
      });
    },
    myCourseClick(item) {
      this.$router.push({
        name: "CourseDetail",
        query: {
          id: item.id,
        },
      });
    },
    myClassClick(item) {
      this.$router.push({
        name: "ClassDetail",
        query: {
          id: item.id,
        },
      });
    },
    exhibitionCourse: function () {
      this.showCourse = true;
    },
    exhibitionClass: function () {
      this.showCourse = false;
    },
    pagePrevClicked(inxex) {
      if(inxex == 0) {
        if (this.query_data[0].PageIndex > 0) {
          this.query_data[0].PageIndex--;
          this.loadMoreCourse();
        }
    
      }else if(inxex == 1){
        if(this.query_data[1].PageIndex > 0){
          this.query_data[1].PageIndex--;
          this.loadMoreClass();
        }
        
      }
    },
    pageNextClicked(inxex) {
      if(inxex == 0) {
        if(this.query_data[0].PageIndex < this.query_data[0].totalPage-1){
          this.query_data[0].PageIndex++;
          this.loadMoreCourse();
        }
        
    
      }else if(inxex == 1){
        if(this.query_data[1].PageIndex < this.query_data[1].totalPage-1){
          this.query_data[1].PageIndex++;
          this.loadMoreClass();
        }
        
      }
    }
  },
};
</script>